<template>
    <DropdownV2
        forceSide="right"
        id="table-options-button"
        @dropdown="dropdownChange"
        :buttonCSS="['icon-hover']"
    >
        <template #button="{ open }">
            <div
                class="w-5 h-10 flex items-center justify-center mx-0.5"
                v-tippy="{
                    content: authUser.can('plus') ? 'Control the data shown on this page' : $en.crm.plus,
                    placement: 'left',
                    maxWidth: '300px',
                }"
            >
                <IconSetting class="h-5 w-5 transition-transform" :class="{ 'rotate-90': open }" />
            </div>
        </template>

        <template #menu>
            <div
                class="table-multi-select-menu bg-black min-w-[260px]"
                v-if="defaultsView == null && defaults != null && defaults.columns != null && defaultsView != 'views'"
            >
                <div class="pb-1.5 px-4 pt-0.5">
                    <p class="text-grey-800 text-14">Display options</p>
                </div>

                <!-- v-if='value == undefined || (! (value.option === false) && defaults.labels[option] != undefined) || value.hidden === true' -->

                <template v-for="(value, option) in defaults.columns">
                    <button v-if="value.hidden !== true" @click.stop="defaultsView = option" class="justify-between">
                        <p>
                            {{
                                defaults.columns[option].input_label != undefined
                                    ? defaults.columns[option].input_label
                                    : $help.capitalizeFirstLetter(option.replace(/_/g, ' '))
                            }}
                        </p>
                        <IconArrowRight class="h-4.5 w-4.5 stroke-white" />
                    </button>
                </template>

                <button @click.stop="defaultsView = 'views'" data-close class="justify-between">
                    <p>Views</p>
                    <IconArrowRight class="h-4.5 w-4.5 stroke-white" />
                </button>

                <!-- <button @click="reset()" data-close>
                    {{ resetLabel == null ? 'Reset options' : resetLabel }}
                </button> -->
            </div>

            <div
                class="table-multi-select-menu bg-black min-w-[260px]"
                v-if="defaultsView == 'views'"
            >
                <div class="flex items-center justify-between px-4 pt-0.5 cursor-pointer">
                    <div class="flex items-center pb-2" @click.stop="defaultsView = null">
                        <IconArrowLeft class="h-4 w-4 stroke-grey-800" />
                        <p class="text-grey-800 text-14 pl-1">Views</p>
                    </div>
                </div>

                <button v-for='(data, template) in defaults.templates' data-close 
                    @click='setTemplate(template, typeof data == "object" && data != null ? data.settings : data)'
                >
                    <InputCheckbox type='radio' :checked='user.template == template' />
                    <p class="pl-2">{{ $help.capitalizeFirstLetter(template) }}</p>
                </button>

                <button data-close class="justify-between" @click='$pop("TableCreateView", {
                    editingModel: null,
                    options: {
                        json: JSON.stringify(toRaw(page.user)), 
                        page_id: defaults.page_id
                    }
                })'>
                    <p>Save view</p>
                    <IconArrowRight class="h-4.5 w-4.5 stroke-white" />
                </button>

                <button data-close class="justify-between" 
                    :disabled='managableTemplates.length == 0'
                    @click='$pop("TableManageViews", {
                        options: {templates: defaults.templates, page_id: defaults.page_id}
                    })'
                >
                    <p>Manage views</p>
                    <IconArrowRight class="h-4.5 w-4.5" 
                        :class='[managableTemplates.length == 0 ? "stroke-grey-900" : "stroke-white" ]' 
                    />
                </button>

                <button @click='getTemplateJSON' data-close class="justify-between">
                    <p>Get JSON</p>
                    <IconArrowRight class="h-4.5 w-4.5 stroke-white" />
                </button>
            </div>

            <div
                class="table-multi-select-menu bg-black min-w-[260px]"
                v-if="defaults != null && defaults.labels != null && defaultsView != null && defaultsView != 'views'"
            >
                <div
                    class="flex items-center justify-between px-4 pt-0.5 cursor-pointer"
                    :class="{
                        'pb-4': defaults.labels[defaultsView] !== undefined && defaults.labels[defaultsView].length > 0,
                    }"
                >
                    <div class="flex items-center pb-2" @click.stop="defaultsView = null">
                        <IconArrowLeft class="h-4 w-4 stroke-grey-800" />
                        <p class="text-grey-800 text-14 pl-1">
                            {{
                                defaults.columns[defaultsView].input_label != undefined
                                    ? defaults.columns[defaultsView].input_label
                                    : $help.capitalizeFirstLetter(defaultsView.replace(/_/g, ' '))
                            }}
                        </p>
                    </div>

                    <div
                        v-tippy="{
                                content: !canActivateMoreColumns ? 'You can only have active ' + page.user.page.max_columns + ' columns on this table' : '',
                                placement: 'right',
                                offset: [0, 40],
                            }"
                        >
                        <Toggle
                            v-if="currentColumn.required !== true"
                            :checked="user.columns[defaultsView]"
                            @toggle="setColumnEnabled(defaultsView)"
                            checkedClass="bg-green-600"
                            :disabled="!canActivateMoreColumns && !user.columns[defaultsView]"
                        />
                    </div>
                </div>

                <template v-for="(value, name) in defaults.labels[defaultsView]">
                    <label class="flex items-center cursor-pointer py-2 px-4" v-if='value !== null'>
                        <input
                            type="checkbox"
                            :name="'labels[' + name + ']'"
                            v-model="user.labels[defaultsView][name]"
                            @change="labelChange(name)"
                            :true-value="true"
                            :false-value="false"
                            class="input-checkbox dark"
                            :disabled="!canActivateMoreColumns && !user.columns[defaultsView]"
                        />

                        <span class="text-14 ml-3 shrink-0" :class="[user.labels[defaultsView][name] ? 'text-white' : 'text-grey-800']">
                            {{ $help.capitalizeFirstLetter(name.replace(/_/g, ' ')) }}
                        </span>
                    </label>
                </template>
            </div>

            <!-- <div v-if='defaults != null && defaults.preDone != null && defaultsView == "pre"'>
                    <button v-for='value in defaults.preDone'
                        @click.stop='setPreDone(value)' type='button'>{{ value }}</button>
                </div> -->

            <!-- <Modal
                ref="modalReset"
                buttonYes="Reset options"
                buttonsClass="bg-white grid-cols-1 lg:grid-cols-2 gap-3"
                :yes="
                    () => {
                        if (this.parentPage != null) {
                            this.parentPage.call().reset()
                        }

                        this.page.call().reset()
                    }
                "
                defaultClass="modal-default"
                :buttonNoEnabled="true"
            >
                <p class="text-19 font-hero text-center lg:pb-4">Are you sure you want to reset your display options?</p>
            </Modal> -->
        </template>
    </DropdownV2>
</template>

<script>
export default {
    props: {
        page: Object,
        parentPage: Object,
        defaults: Object,
        user: Object,
        resetLabel: String,
        tableLabelChangeCheck: {
            type: Function,
            default: function (labels, label, enabled) {},
        },
    },

    //value: null

    data() {
        return {
            defaultsView: null,
        }
    },

    methods: {
        labelChange(name) {
            let hasEnabled = false

            if (! this.defaults.columns[this.defaultsView].required) {
                for (let i in this.user.labels[this.defaultsView]) {
                    if (!hasEnabled && this.user.labels[this.defaultsView][i]) {
                        hasEnabled = true
                    }
                }
            } else {
                hasEnabled = true;
            }

            if (this.parentPage != null) {
                this.tableLabelChangeCheck(
                    this.parentPage.user.labels[this.defaultsView],
                    name,
                    this.parentPage.user.labels[this.defaultsView][name],
                )
            } else {
                this.tableLabelChangeCheck(this.page.user.labels[this.defaultsView], name, this.page.user.labels[this.defaultsView][name])
            }

            if (hasEnabled != this.page.user.columns[this.defaultsView]) {
                this.page.user.columns[this.defaultsView] = !this.page.user.columns[this.defaultsView]
            }

            if (this.parentPage != null) {
                this.parentPage.call().save()
            } else {
                this.page.call().save()
            }
        },

        setColumnEnabled(defaultsView) {
            // console.log('setColumnEnabled', defaultsView)
            // console.log('setColumnEnabled', this.user.columns[defaultsView])
            // this.user.columns[defaultsView] = !this.user.columns[defaultsView]

            let hasEnabled = false

            for (let i in this.user.labels[this.defaultsView]) {
                if (this.user.labels[this.defaultsView][i]) {
                    hasEnabled = true
                }
            }

            if (!hasEnabled && !this.page.user.columns[this.defaultsView]) {
                this.page.user.labels[this.defaultsView] = { ...this.page.defaults.labels[this.defaultsView] }
            }

            this.page.user.columns[this.defaultsView] = !this.page.user.columns[this.defaultsView]

            if (this.parentPage != null) {
                this.parentPage.call().save()
            } else {
                this.page.call().save()
            }
        },

        dropdownChange(d) {
            if (d == false) {
                this.defaultsView = null
            }
        },

        reset() {
            this.$pop('confirm', {
                options: {
                    action: '',
                    submitFunction: () => {
                        if (this.parentPage != null) {
                            this.parentPage.call().reset()
                        }

                        this.page.call().reset()
                    },
                    message:
                        "Are you sure you want to reset this page's display options? Your page layout will be restored to its default view.",
                    button: 'Reset page',
                    method: null,
                    head: 'Reset page',
                },
            })
        },

        getTemplateJSON() {
            let j = JSON.stringify(this.page.call().page.user);
            navigator.clipboard.writeText(j)
                .then(() => {
                    this.$event.$emit('toast-new-message', 'JSON has been copied to your clipboard');
                })
                .catch((err) => {
                    this.$event.$emit('toast-new-message', 'JSON could not be copied to your clipboard');
                });
        },

        setTemplate(name, json) {
            this.page.call().setTemplate(name, json)
        }
    },

    computed: {
        disableColumns() {
            let active = 0
            for (let i in this.user.columns) {
                active += this.user.columns[i] ? 1 : 0
            }

            return this.defaults.limits.columns !== undefined && active >= this.defaults.limits.columns
        },

        currentColumn() {
            return typeof this.defaults.columns[this.defaultsView] == 'object'
                ? this.defaults.columns[this.defaultsView]
                : { enabled: this.defaults.columns[this.defaultsView] }
        },

        activeColumns() {
            let active = 0
            for (let i in this.user.columns) {
                active += this.user.columns[i] ? 1 : 0
            }

            return active
        },

        canActivateMoreColumns() {
            return this.activeColumns <= (this.page.user.page.max_columns != undefined ? this.page.user.page.max_columns : Infinity)
        },

        authUser() {
            return this.$authSanctum.getUser()
        },

        managableTemplates() {
            let temp = [];

            for (const [key, value] of Object.entries(this.defaults.templates)) {
                if (value != null && typeof value == 'object') {
                    temp.push(value)
                }
            }

            return temp
        }
    },
}
</script>
